// The query string the page ARRIVED with, snapshotted at module evaluation.
//
// Two boot-time strippers rewrite `location.search` before React mounts:
// `adoptEntryProjectFromUrl` (lib/initial-restore.ts, reached at MODULE-EVAL time
// through `workspace-store`'s `computeInitialRestore()`) deletes `project`, and
// `clearEntryLandingQuery` (lib/entry-landing-measurement.ts) deletes the
// `mira_entry_*` handoff keys. Both run strictly before any mount effect, so a
// measurement that reads `location.search` from an effect sees a URL with the
// interesting parameters already gone and silently reports the default branch
// forever.
//
// This module has NO imports on purpose, so it is cheap to evaluate first and
// cannot drag a stripper in ahead of itself. `main.tsx` imports it before
// anything that can rewrite the URL; that import IS the guarantee. Everything
// else reads the snapshot rather than the live location.

const arrivalSearch: string =
  typeof globalThis.location === "undefined" ? "" : globalThis.location.search;

/** The query string as the page was opened, before any boot-time rewrite. */
export function arrivalQuery(): string {
  return arrivalSearch;
}
